<div>
    <div *ngIf="linkInfo?.pricingInformation else noInfo" [innerHTML]="linkInfo.pricingInformation | unescapehtml | sanitize">
    </div>
    <ng-template #noInfo>
        <p>There is no pricing information at this time</p>
    </ng-template>
</div>
